document.addEventListener('alpine:init', () => {
  Alpine.data('personFilter', () => ({
    selectedCategories: [],
    toggle(category) {
      if (this.selectedCategories.includes(category)) {
        this.selectedCategories = this.selectedCategories.filter(x => x != category)
      }
      else {
        this.selectedCategories = [];
        this.selectedCategories.push(category)
      }
    },
    isSelected(category) {
      if(this.selectedCategories.length > 0) {
        return this.selectedCategories.includes(category)
      } else return true
    }
  }))
});
